(() => {
  const heroSelector = '[data-yhs-pcv2-hero]';
  const railSelector = '[data-yhs-pcv2-card-rail]';

  const initialiseHero = (hero) => {
    if (!hero || hero.dataset.yhsPcv2Ready === 'true') return;
    hero.dataset.yhsPcv2Ready = 'true';

    hero.addEventListener('keydown', (event) => {
      if (event.defaultPrevented || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

      const direction = event.key === 'ArrowLeft' ? 'previous' : 'next';
      const control = hero.querySelector(`button[name="${direction}"]`);
      if (!control) return;

      event.preventDefault();
      control.click();
    });
  };

  const initialiseRail = (rail) => {
    if (!rail || rail.dataset.yhsPcv2RailReady === 'true') return;
    rail.dataset.yhsPcv2RailReady = 'true';

    const updateTabStop = () => {
      rail.tabIndex = rail.scrollWidth > rail.clientWidth + 1 ? 0 : -1;
    };

    updateTabStop();
    requestAnimationFrame(updateTabStop);
    new ResizeObserver(updateTabStop).observe(rail);

    rail.addEventListener('keydown', (event) => {
      if (event.target !== rail || event.defaultPrevented || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

      const firstCard = rail.querySelector('.yhs-pcv2-card');
      if (!firstCard) return;

      const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      const direction = event.key === 'ArrowLeft' ? -1 : 1;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      event.preventDefault();
      rail.scrollBy({
        left: direction * (firstCard.getBoundingClientRect().width + gap),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    });
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.(heroSelector)) initialiseHero(root);
    if (root.matches?.(railSelector)) initialiseRail(root);
    root.querySelectorAll?.(heroSelector).forEach(initialiseHero);
    root.querySelectorAll?.(railSelector).forEach(initialiseRail);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
